/* Seamless marquee: the -50% loop only works when a single group is wider than the
   container, otherwise a gap opens on the right at the end of each cycle. */
(function () {
  var MAX_REPEATS = 60;

  function build(el) {
    var track = el.querySelector('.bl-marquee__track');
    if (!track) return;

    var base = track.querySelector('.bl-marquee__group');
    if (!base) return;

    // restore to a single pristine group before re-measuring
    if (!base.dataset.blSeed) base.dataset.blSeed = base.innerHTML;
    base.innerHTML = base.dataset.blSeed;
    Array.prototype.slice.call(track.querySelectorAll('.bl-marquee__group')).forEach(function (g, i) {
      if (i > 0) g.remove();
    });

    var unit = Array.prototype.slice.call(base.children).map(function (n) { return n.cloneNode(true); });
    if (!unit.length) return;

    var seedWidth = base.offsetWidth;
    if (!seedWidth) return;

    var containerWidth = el.offsetWidth;
    var repeats = 1;
    while (base.offsetWidth < containerWidth && repeats < MAX_REPEATS) {
      unit.forEach(function (n) { base.appendChild(n.cloneNode(true)); });
      repeats++;
    }

    var clone = base.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    delete clone.dataset.blSeed;
    track.appendChild(clone);

    /* Configure a speed, not a duration. The animation travels one group's
       width per cycle, so a fixed duration makes a short strip crawl and a long
       one race; deriving the duration from the width keeps every strip moving
       at the same px/s regardless of how much text it carries. */
    var speed = parseFloat(el.dataset.blSpeed || '');
    var seconds = speed > 0
      ? base.offsetWidth / speed
      : parseFloat(el.dataset.blDuration || '40') * repeats;
    track.style.animationDuration = seconds + 's';
  }

  function init() {
    document.querySelectorAll('.bl-marquee').forEach(build);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(init, 200);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // fonts change text width, so re-measure once they land
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(init);
  // theme editor re-renders sections without a page load
  document.addEventListener('shopify:section:load', init);
})();
